'use client';

import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { OrganizationOverview } from './components/organization-overview';
import { OrganizationMembers } from './components/organization-members';

import { withRequiredPermission } from '@/components/auth/with-required-permission';
import { PERMISSIONS } from '@/hooks/use-perm';

export default withRequiredPermission(OrganizationPage, PERMISSIONS.TEAM_VIEW);

function OrganizationPage() {
  const { t } = useTranslation('settings');
  
  return (
    <div className="flex flex-col space-y-4 sm:space-y-6">
      {/* Header */}
      <div className="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
        <div>
          <h2 className="text-xl font-bold tracking-tight">{t('organization.title')}</h2>
          <p className="text-muted-foreground mt-1 text-sm">{t('organization.description')}</p>
        </div>
      </div>

      {/* Tabs */}
      <Tabs defaultValue="overview" className="w-full">
        <TabsList className="mb-6 w-full sm:grid sm:grid-cols-2">
          <TabsTrigger value="overview">{t('organization.tabs.overview')}</TabsTrigger>
          <TabsTrigger value="members">{t('organization.tabs.members')}</TabsTrigger>
        </TabsList>

        <TabsContent value="overview" className="space-y-6">
          <OrganizationOverview />
        </TabsContent>

        <TabsContent value="members" className="space-y-6">
          <OrganizationMembers />
        </TabsContent>
      </Tabs>
    </div>
  );
}
